// Google Analytics 4 Configuration
export const GA4_CONFIG = {
  MEASUREMENT_ID: 'G-XXXXXXXXXX', // Replace with actual GA4 measurement ID
  API_SECRET: 'XXXXXXXXXX', // Replace with actual API secret
  STREAM_ID: 'XXXXXXXXXX', // Replace with actual stream ID
  ENABLED: true,
  DEBUG: process.env.NODE_ENV === 'development'
};

// Event names for consistent tracking
export const ANALYTICS_EVENTS = {
  // Page view events
  PAGE_VIEW: 'page_view',

  // Booking form events
  BOOKING_FORM_START: 'booking_form_start',
  BOOKING_FORM_STEP: 'booking_form_step',
  BOOKING_FORM_COMPLETE: 'booking_form_complete',
  BOOKING_FORM_ABANDON: 'booking_form_abandon',

  // Service selection events
  SERVICE_SELECT: 'service_select',
  SERVICE_DESELECT: 'service_deselect',

  // Contact interaction events
  PHONE_CLICK: 'phone_click',
  EMAIL_CLICK: 'email_click',
  WHATSAPP_CLICK: 'whatsapp_click',

  // Video events
  VIDEO_PLAY: 'video_play',
  VIDEO_PAUSE: 'video_pause',
  VIDEO_COMPLETE: 'video_complete',

  // CTA button events
  CTA_CLICK: 'cta_click',
  BUTTON_CLICK: 'button_click',

  // Conversion events
  BOOKING_CONVERSION: 'booking_conversion',
  LEAD_CONVERSION: 'lead_conversion',

  // Navigation events
  NAVIGATION_CLICK: 'navigation_click',
  MENU_CLICK: 'menu_click'
};

// Global trackEvent function
export const trackEvent = (eventName: string, params: Record<string, any> = {}) => {
  if (typeof window === 'undefined') return;

  // Log to console in debug mode
  if (GA4_CONFIG.DEBUG) {
    console.log(`[Analytics] ${eventName}:`, params);
  }

  // Google Analytics
  if ((window as any).gtag) {
    (window as any).gtag('event', eventName, params);
  }
};

// Specific trackers
export const trackLeadSaved = (leadId: string, value?: number) => {
  trackEvent(ANALYTICS_EVENTS.LEAD_CONVERSION, {
    lead_id: leadId,
    value: value,
    currency: 'KES'
  });
};

export const trackWhatsAppClick = (source: string, pageName: string) => {
  trackEvent(ANALYTICS_EVENTS.WHATSAPP_CLICK, {
    source: source,
    page_name: pageName
  });
};

export const trackBookingStep = (step: number, stepName: string) => {
  trackEvent(ANALYTICS_EVENTS.BOOKING_FORM_STEP, {
    step: step,
    step_name: stepName
  });
};

export const trackBookingComplete = (bookingId: string, total: number) => {
  trackEvent(ANALYTICS_EVENTS.BOOKING_FORM_COMPLETE, {
    booking_id: bookingId,
    value: total,
    currency: 'KES'
  });
};
